module.exports = __webpack_public_path__ + "static/media/logo-green.e4e984d8.png";